import React, { useCallback, useState } from 'react';
import { Modal, Input, Button, Form } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useCommands } from '@remirror/react';
import CommandButton from '../CommandButton';

export const LinkButton = React.memo(() => {
  const [form] = Form.useForm();
  const { focus, updateLink } = useCommands();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);
  const handleOk = useCallback(() => form.submit(), [form]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
    form.resetFields();
  }, [setIsModalOpen, form]);

  const onFinish = useCallback(
    (values) => {
      const { url } = values;
      if (url) {
        let formattedUrl = url;
        if (!/^https?:\/\//i.test(url)) {
          formattedUrl = 'https://' + url;
        }
        updateLink({ href: formattedUrl });
        focus();
        setIsModalOpen(false);
        form.resetFields();
      }
    },
    [focus, updateLink, setIsModalOpen, form]
  );

  return (
    <>
      <CommandButton aria-label={'Link'} onClick={showModal} icon={<LinkOutlined className="lg" />} />
      <Modal
        destroyOnClose
        title="Insert Link"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Add Link
          </Button>,
        ]}
      >
        <Form form={form} onFinish={onFinish}>
          <Form.Item name="url" rules={[{ required: true, message: 'Please input the URL!' }]}>
            <Input placeholder="Enter URL (e.g., www.example.com or https://www.example.com)" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
});

export default LinkButton;
